module.exports = __webpack_public_path__ + "img/pro.3d860471.png";